import { useContext } from 'react';
import { PromptContext } from '../contexts/promptContext';

export const usePromptDialog = () => useContext(PromptContext);
